import {connect} from 'react-redux';
import {Graphics as Component} from './Graphics';
import {
  gelBoxOpen,
  showModal,
  setModal,
  toggleToolTipControls,
  ejectGelFromGelBox,
  setGelInBox,
  setGelOnShelf,
  setGelInScene,
  setGelHeld,
  toggleGelboxTooltipsControls,
  toggleGelboxPipetteModal,
  toggleGelboxOrientationModal,
  decGelOrientation,
  incGelOrientation,
  setGelActiveLane,
  setGelLane,
  setPipetteSolution
} from '@learningblocks/protocol-redux/lib/Actions';


function mapStateToProps(state, ownProps) {
  return {
    id: ownProps.id,
    type: state.notebook.protocolSection.scene.apparatus.gelBoxes[ownProps.id - 1].type,

    open: state.notebook.protocolSection.scene.apparatus.gelBoxes[ownProps.id - 1].open,
    gelOrientation: state.notebook.protocolSection.scene.apparatus.gelBoxes[ownProps.id - 1].gelOrientation,
    orientation: state.notebook.protocolSection.scene.apparatus.gelBoxes[ownProps.id - 1].orientation,
    volume: state.notebook.protocolSection.scene.apparatus.gelBoxes[ownProps.id - 1].volume,
    containsGel: state.notebook.protocolSection.scene.apparatus.gelBoxes[ownProps.id - 1].containsGel,
    anodeConnected: state.notebook.protocolSection.scene.apparatus.gelBoxes[ownProps.id - 1].anodeConnected,
    cathodeConnected: state.notebook.protocolSection.scene.apparatus.gelBoxes[ownProps.id - 1].cathodeConnected,
    containsBuffer:state.notebook.protocolSection.scene.apparatus.gelBoxes[ownProps.id - 1].containsBuffer,
    showTooltipControls: state.notebook.protocolSection.scene.apparatus.gelBoxes[ownProps.id - 1].showTooltipControls,

    showGelPipetteModal: state.notebook.protocolSection.scene.apparatus.gelBoxes[ownProps.id - 1].showGelPipetteModal,
    showOrientationModal: state.notebook.protocolSection.scene.apparatus.gelBoxes[ownProps.id - 1].showOrientationModal,

    pipetteId: state.notebook.protocolSection.scene.apparatus.gelBoxes[ownProps.id - 1].pipetteId,
    gelId: state.notebook.protocolSection.scene.apparatus.gelBoxes[ownProps.id - 1].gelId,

    lanes:  (state.notebook.protocolSection.scene.apparatus.gelBoxes[ownProps.id - 1].gelId !== null)?state.notebook.protocolSection.scene.apparatus.agaroseGel[0].lanes:null,
    activeLane:  (state.notebook.protocolSection.scene.apparatus.gelBoxes[ownProps.id - 1].gelId !== null)?state.notebook.protocolSection.scene.apparatus.agaroseGel[0].activeLane:null,

    interactionProps: {
      pipettes: state.notebook.protocolSection.scene.apparatus.pipettes,
      solutions: state.notebook.protocolSection.scene.apparatus.solutions,
    }
  }
}

function mapDispatchToProps(dispatch) {

  return {
    gelBoxOpen: (data) => {
      dispatch(gelBoxOpen(data))
    },
    showModal: (data) => {
      dispatch(showModal(data))
    },
    setModal: (data) => {
      dispatch(setModal(data))
    },
    toggleToolTipControls: (data) => {
      dispatch(toggleToolTipControls(data))
    },
    ejectGelFromGelBox: (data) => {
      dispatch(ejectGelFromGelBox(data))
    },
    setGelInBox: (data) => {
      dispatch(setGelInBox(data))
    },
    setGelOnShelf: (data) => {
      dispatch(setGelOnShelf(data))
    },
    setGelInScene: (data) => {
      dispatch(setGelInScene(data))
    },
    setGelHeld: (data) => {
      dispatch(setGelHeld(data))
    },

    toggleGelboxTooltipsControls: (data) => {
      dispatch(toggleGelboxTooltipsControls(data))
    },

    toggleGelboxPipetteModal: (data) => {
      dispatch(toggleGelboxPipetteModal(data))
    },
    toggleGelboxOrientationModal: (data) => {
      dispatch(toggleGelboxOrientationModal(data))
    },

    decGelOrientation: (data) => {
      dispatch(decGelOrientation(data))
    },
    incGelOrientation: (data) => {
      dispatch(incGelOrientation(data))
    },

    setGelLane: (data) => {
      dispatch(setGelLane(data))
    },
    setGelActiveLane: (data) => {
      dispatch(setGelActiveLane(data))
    },
    setPipetteSolution: (data) => {
      dispatch(setPipetteSolution(data))
    },
  };


}
export const Graphics = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
